(function() {
	'use strict';

    var unserialize = avm.require('avast.url.unserialize'),
		qs = unserialize(),
        urlCampaignMarker = qs['x-CampaignMarker'],
        urlEnablecoupon = qs.enablecoupon,
        cartLinks = document.querySelectorAll('[data-role="cart-link"]');

        cartLinks.forEach(function(cartLink){
            // href editing on load
            var link = cartLink.getAttribute('href'),
                url = new URL(link, window.location.origin);

            if(urlCampaignMarker) {
                url.searchParams.set('x-CampaignMarker', urlCampaignMarker);
            }
            if(urlEnablecoupon) {
                url.searchParams.set('enablecoupon', urlEnablecoupon);
            }
            cartLink.setAttribute('href', url.toString());

            // href editing on click
            cartLink.addEventListener('click', function(e) {
                var clickUrl = new URL(cartLink.getAttribute('href'), window.location.origin);
                if(urlCampaignMarker) {
                    clickUrl.searchParams.set('x-CampaignMarker', urlCampaignMarker);
                }
                if(urlEnablecoupon) {
                    clickUrl.searchParams.set('enablecoupon', urlEnablecoupon);
                }
                cartLink.setAttribute('href', clickUrl.toString());
            });
        });
        
})();